<template>
  <ul v-loading="!popupData.length">
    <!--  <ul>-->
    <li class="close" @click="closePopup">x</li>
    <li
      v-for="(item,index) in popupData"
      :key="item.type"
      class="detail-item"
    >
      <div class="detail-number">0{{ index + 1 }}</div>
      <div class="detail-container">
        <div class="line-one">
          <span>约{{ item.timeMiniute }}分钟</span>
          <span>{{ item.distanceKm }}公里</span>
          <span>{{ item.traffic_lights }}个红绿灯</span>
        </div>
        <div class="line-two">
          途经：{{ item.roadFour.join(">") }}
        </div>
      </div>
      <el-button class="detail-button" @click="selectTour(index)">设定为规划路线</el-button>
    </li>
  </ul>
</template>

<script>
export default {
  name: "PopupDetail",
  props: {
    threeData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  emits: ["closePopup", "setRoad"],
  data() {
    return {
      loading: true,
      popupData: []
    };
  },
  watch: {
    threeData: {
      handler(val) {
        val.forEach(item => {
          item.distanceKm = (item.distance / 1000).toFixed(2);
          item.timeMiniute = (item.duration / 60).toFixed(0);
          item.strategyCode = item.strategy;
          const hasRoad = item.steps.filter(step => {
            return step.road; // 只返回有路属性的
          });
          const uniqueArr = this.deduplication(hasRoad, "road");
          item.roadFour = this.getLessThanFour(uniqueArr);
        });
        this.popupData = val;
      },
      immediate: true
    }

  },
  mounted() {
    setTimeout(() => {
      console.log(this.popupData);
    }, 1000);
  },
  methods: {
    /**
     * 返回的如果road是重复的话, 要去除
     * */
    deduplication(arr, key) {
      return Array.from(new Set(arr.map(item => item[key]))).map(val => {
        return val;
      });
    },
    /**
     * 数组不多于4个, 全部返回; 多余4个, 均匀返回
     * */
    getLessThanFour(arr) {
      const length = arr.length;
      if (length <= 4) {
        // 不到四个元素，返回全部元素
        return arr.slice(0);
      } else {
        // 超过四个元素，按照 1/4 的间隔返回指定元素
        const interval = Math.floor(length / 4);
        const indexes = [0, interval - 1, interval * 2 - 1, length - 1];
        return indexes.map(index => arr[index]);
      }
    },
    /**
     * 点击设置为规划路线
     * @param {string} val - 点击的index
     * */
    selectTour(val) {
      console.log(val);
      this.$emit("setRoad", val);
    },
    closePopup() {
      this.$emit("closePopup");
    }
  }
};
</script>

<style scoped lang="scss">
li.detail-item:hover {
  background: #ECEEF2;

  .detail-number {
    background: #EBAF79;
  }
}

.detail-item {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;

  padding-left: 10px;
  padding-right: 24px;

  + .detail-item {
    border-top: #CCCCCC solid 1px;
  }

}

.detail-number {
  width: 48px;
  height: 28px;

  background: #79EB86;
  border-radius: 0 0 6px 6px;
  margin-right: 28px;
  text-align: center;
  line-height: 28px;
  color: #FBFBFB;
  align-self: flex-start;
}

.detail-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .line-one {
    font-size: 16px;
    color: #333333;
    height: 30px;

    span + span::before {
      content: "|";
      margin: 0 10px;
    }
  }

  .line-two {
    font-size: 14px;
    color: #999999;
    letter-spacing: 2px;
  }
}

.detail-button {
  width: 156px;
  height: 40px;
  background: #75B8E6;
  border-radius: 6px;
  color: #FBFBFB;
}

.close {
  user-select: none;
  position: absolute;
  top: 3px;
  right: 6px;
}

</style>
